import React from 'react';
import { AlertTriangle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 px-4 bg-black text-white" data-id="element-101">
      <div className="max-w-4xl mx-auto" data-id="element-102">
        <div className="text-center mb-12" data-id="element-103">
          <AlertTriangle className="w-16 h-16 text-brand-yellow mx-auto mb-6" data-id="element-104" />
          <h2 className="text-3xl md:text-4xl font-heading font-black leading-tight" data-id="element-105">
            ¿Seguís dependiendo de pastillas para aliviar problemas que antes se
            resolvían de forma natural?
          </h2>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 md:p-12" data-id="element-106">
          <h3 className="text-2xl font-bold text-brand-yellow mb-8 text-center uppercase tracking-wider" data-id="element-107">
            ESTE LIBRO ES PARA VOS SI…
          </h3>

          <ul className="space-y-6" data-id="element-108">
            {['Cada vez que te duele algo, lo primero que hacés es buscar una pastilla', 'Sentís que solo estás tapando síntomas, pero el problema sigue ahí', 'Querés cuidar mejor a tu familia con soluciones más naturales', 'Te prometiste dejar de depender tanto de medicamentos', 'Sentís culpa cuando medicás demasiado rápido a tus hijos', 'Querés alternativas naturales simples y organizadas', 'Sabés que existen remedios naturales, pero no sabés por dónde empezar'].map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-109">
                <span className="text-2xl flex-shrink-0" data-id="element-110">🌿</span>
                <span className="text-lg md:text-xl font-medium text-gray-200" data-id="element-111">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="mt-16 text-center max-w-3xl mx-auto" data-id="element-112">
          <p className="text-xl text-gray-300 mb-6 font-medium" data-id="element-113">
            Antes muchas familias sabían cómo aliviar problemas cotidianos de
            forma natural…
          </p>
          <p className="text-xl text-gray-300 mb-10 font-medium" data-id="element-114">
            Pero con el tiempo dejamos de usar conocimientos simples que pasaron
            de generación en generación.
          </p>

          <div className="bg-zinc-900 p-8 rounded-xl text-left border-l-4 border-brand-red" data-id="element-115">
            <p className="text-xl font-bold mb-6 text-white" data-id="element-116">
              👉 Hoy muchas personas sienten que:
            </p>
            <ul className="space-y-4 mb-8" data-id="element-117">
              {['toman demasiados medicamentos', 'perdieron conexión con soluciones naturales', 'no saben qué hacer sin recurrir inmediatamente a químicos', 'dependen constantemente de la farmacia'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-300 text-lg" data-id="element-118">
                  <XCircle className="w-5 h-5 text-brand-red flex-shrink-0" data-id="element-119" />
                  <span data-id="element-120">{item}</span>
                </li>)}
            </ul>
            <p className="text-xl font-bold text-brand-yellow" data-id="element-121">
              Y eso genera miedo, frustración y sensación de dependencia.
            </p>
          </div>

          <h3 className="text-3xl font-heading font-black mt-12 text-white uppercase" data-id="element-122">
            Por eso creamos esta guía.
          </h3>
        </div>
      </div>
    </section>;
}